import v8n from "v8n";

// priorityの小さいものが優先してメッセージ表示される
export default {
  required: {
    message: "未入力です",
    priority: 0,
    validate: (value) => {
      return v8n().not.empty().test(value);
    },
  },

  checked: {
    message: "未選択です",
    priority: 0,
    validate: (value) => {
      return value;
    },
  },

  email: {
    message: "メールアドレスの形式が正しくありません",
    priority: 1,
    validate: (value) => {
      if (value === "") return true;

      return v8n()
        .pattern(/[^\s@]+@[^\s@]+\.[^\s@]+/)
        .test(value);
    },
  },

  phone: {
    message: "電話番号の形式が正しくありません",
    priority: 1,
    format: (value) => {
      const formatted = new libphonenumber.AsYouType("JP").input(value);
      return formatted;
    },
    validate: (value) => {
      if (value === "") return true;

      return (
        v8n()
          // .pattern(/^\d{11}$|^\d{3,4}-\d{3,4}-\d{4}/)
          .pattern(/^\d{10,11}$|^0\d{1,3}-\d{2,4}-\d{3,4}/)
          .test(value)
      );
    },
  },

  zip: {
    message: "郵便番号の形式が正しくありません",
    priority: 1,
    format: (value) => {
      return value.replace("-", "");
    },
    validate: (value) => {
      if (value === "") return true;
      return v8n()
        .pattern(/^\d{3}-?\d{4}$/)
        .test(value);
    },
  },

  max99: {
    message: "1-99の間で入力してください",
    priority: 1,
    validate: (value) => {
      if (value === "") return true;
      return v8n().greaterThanOrEqual(1).lessThanOrEqual(99).test(value);
    },
  },
};
